
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import AddIcon from '../../../Icons/AddIcon.vue';
/**
- A feature card consist of image, title, content (can be in list/array) and amount information
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralFeatureCard',
  components: {
    EuCard,
    AddIcon
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set image
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * Set content
     */
    content: {
      type: [String, Array, Function, Object]
    },
    /**
     * Set upToLabel
     */
    upToLabel: {
      type: String,
      default: ''
    },
    /**
     * Set upToValue
     */
    upToValue: {
      type: String,
      default: ''
    }
  },
  methods: {
    computedBackground(val: any) {
      return `background-image: url(${val})`;
    },
    isContentWithList(content: any) {
      return Array.isArray(content);
    },
    isStringContent(content: any) {
      return typeof content === 'string';
    }
  }
});
